// extracted by mini-css-extract-plugin
module.exports = {"container":"_1VPgo2Y__UwrTWNn9-Ngs9"};